module.exports = __webpack_public_path__ + "fonts/font.dfff538.woff";